/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitTag,
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';
import {
    PressKitThumbnailUrls,
    PressKitThumbnailUrlsFromJSON,
    PressKitThumbnailUrlsFromJSONTyped,
    PressKitThumbnailUrlsToJSON,
} from './PressKitThumbnailUrls';

/**
 * プレスキットロゴの詳細
 * @export
 * @interface PressKitLogoDetail
 */
export interface PressKitLogoDetail {
    /**
     * PressKit Logo UUID(v4)
     * @type {string}
     * @memberof PressKitLogoDetail
     */
    id: string;
    /**
     * 企業が登録したファイルの名前（キャプション）
     * @type {string}
     * @memberof PressKitLogoDetail
     */
    title: string;
    /**
     * 企業が登録したファイルの名前（title+extension）
     * @type {string}
     * @memberof PressKitLogoDetail
     */
    filename: string;
    /**
     * 企業が登録したファイルの説明文。設定無しは''になる。
     * @type {string}
     * @memberof PressKitLogoDetail
     */
    description: string;
    /**
     * ファイル拡張子（原則英語小文字）
     * @type {string}
     * @memberof PressKitLogoDetail
     */
    extension: PressKitLogoDetailExtensionEnum;
    /**
     * ファイルのサイズ（単位はbytes）
     * @type {number}
     * @memberof PressKitLogoDetail
     */
    fileSize: number;
    /**
     * ラスター画像の幅。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PressKitLogoDetail
     */
    width: number | null;
    /**
     * ラスター画像の高さ。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PressKitLogoDetail
     */
    height: number | null;
    /**
     * 
     * @type {PressKitThumbnailUrls}
     * @memberof PressKitLogoDetail
     */
    thumbnailUrls: PressKitThumbnailUrls;
    /**
     * 画像のダウンロード用URL。別ドメイン。
     * @type {string}
     * @memberof PressKitLogoDetail
     */
    downloadUrl: string;
    /**
     * 企業が設定しているタグの一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitLogoDetail
     */
    readonly tags: Array<PressKitTag>;
}

/**
* @export
* @enum {string}
*/
export enum PressKitLogoDetailExtensionEnum {
    Jpg = 'jpg',
    Png = 'png'
}

export function PressKitLogoDetailFromJSON(json: any): PressKitLogoDetail {
    return PressKitLogoDetailFromJSONTyped(json, false);
}

export function PressKitLogoDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitLogoDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'filename': json['filename'],
        'description': json['description'],
        'extension': json['extension'],
        'fileSize': json['file_size'],
        'width': json['width'],
        'height': json['height'],
        'thumbnailUrls': PressKitThumbnailUrlsFromJSON(json['thumbnail_urls']),
        'downloadUrl': json['download_url'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitLogoDetailToJSON(value?: PressKitLogoDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'filename': value.filename,
        'description': value.description,
        'extension': value.extension,
        'file_size': value.fileSize,
        'width': value.width,
        'height': value.height,
        'thumbnail_urls': PressKitThumbnailUrlsToJSON(value.thumbnailUrls),
        'download_url': value.downloadUrl,
    };
}

